import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';

@Injectable()
export class ColorService {

  constructor(
    private http: Http,
  ) { }

  get () {
    return this.http.get(`${ environment.API_URL }colores`)
      .map(res => {
        return res.json().data;
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/color/color.service.ts